import { computed } from 'mobx'
import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type AccessRequest } from 'entities/Users/model/AccessRequest'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { checkHasCustomPermissions } from 'entities/Permissions'

export class RowAccessRequest extends RowBase<AccessRequest> {
  constructor(origin: AccessRequest, private _entities: IEntitiesStore) {
    super(origin)

    makeObservableRowBase(this, {
      fullName: computed,
      email: computed,
      role: computed,
      roleLabel: computed,
      avatarInfo: computed,
      requestOn: computed,
      createdAt: computed,
      hasCustomPermissions: computed,
    })
  }

  get fullName() {
    return this.origin.user.fullName
  }

  get email() {
    return this.origin.user.email
  }

  get role() {
    return this.origin.user.role
  }

  get roleLabel() {
    return this.origin.user.roleLabel
  }

  get requestOn() {
    return this.origin.user.requestOn
  }

  get avatarInfo() {
    return this.origin.user.avatarInfo
  }

  get createdAt() {
    return this.origin.createdAt
  }

  get hasCustomPermissions(): boolean {
    return checkHasCustomPermissions(
      this.origin.user.permissions,
      this.origin.user.role,
      this._entities.permissionsStore.permissions
    )
  }
}
